




























import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseModel from "@/models/base/BaseModel.model";
import HttpClient from "@/core/HttpResources/BaseHttpClient";
import ApiQueryOption from "@/models/base/ApiQueryOption.model";
import { Utils } from "@/core/Utils";

@Component({})
export default class CiudadanoBuscador extends Vue {
  @Prop() public action!: string;
  @Prop() public controller!: string;
  @Prop() public placeholder!: string;
  @Prop() public size!: string;
  @Prop() public customClasses!: string;
  @Prop() public whereParams!: string;
  @Prop() public value!: number | object | null;

  loading = false;
  term = String();
  client = new HttpClient(this.controller || "personas");

  get clases(){
    let r = this.customClasses || String();
    if(this.size){
      r += this.size
    }
    return r;
  }
  get isCedula() {
    return Utils.isCedula(this.term);
  }
  get _placeholder() {
    return this.placeholder || "Buscar...";
  }
  get queryParamsc() {
    let ced = this.term.replace(/-/g, "");
    return {
      cedula: ced
    };
  }
  async getDataAsync(value: string) {
    if (!value) return;
    try {
      this.loading = true;
      let result = await this.client.getAsync<any>(this.action || `FindOrSyncJCE`,this.queryParamsc);
      this.onSelect(result);
    } catch (e) {
      this.$buefy.toast.open({
        message: "No se pudo completar la busqueda del ciudadano.",
        type: "is-danger"
      });
    } finally {
      this.loading = false;
    }
  }

  onSelect(value: any) {
    this.$emit("select", value);
    this.$emit("input", value ? value.id : undefined);
  }

  // @Watch("value")
  // onValue(value: any) {
  //   if (!value) {
  //     this.onSelect(value);
  //     return;
  //   }
  //   if (isNaN(value)) {
  //     this.onSelect(value);
  //     return;
  //   }

  //   if (Utils.isCedula(value)) this.getDataAsync(value);
  // }
}
